import { PortableText } from '@portabletext/react';
import React from 'react';
import MarkerLg from './images/marker_lg.svg';
import MarkerSm from './images/marker_sm.svg';
import * as styles from './TimelineItems.module.scss';

export const TimelineItems = ({ items }) => {
  const flags = new Map([
    ['eu', <span className={styles.flag}>🇪🇺</span>],
    ['us', <span className={styles.flag}>🇺🇸</span>],
  ]);

  const components = {
    block: {
      sectionTitle: ({ children }) => (
        <p className={styles.sectionTitle}>
          <strong>{children}</strong>
        </p>
      ),
      normal: ({ children }) => <p className={styles.normal}>{children}</p>,
    },
  };

  const cards = items.map(({ _key, year, description, locations }, index) => (
    <div key={_key} className={`${styles.card} mb-4`}>
      {index === 0 ? <MarkerLg className={styles.marker} /> : <MarkerSm className={styles.marker} />}

      <p className="h4">
        <strong className="mr-1">{year}</strong>
        <span>{locations.map((location) => flags.get(location))}</span>
      </p>
      <PortableText value={description} components={components} />
    </div>
  ));

  return cards;
};
